<div class="input-group">
    <input class="form-control" [formControl]="control" [id]="id" [name]="id" [title]="title"
        [placeholder]="placeholder" [min]="minDate" [max]="maxDate" (dateChange)="dateChangeEvent($event)"
        [ngClass]="{'is-invalid':control.touched && control.invalid}" [matDatepickerFilter]="dayFilter"
        [matDatepicker]="picker">

    <button class="form-control " (click)="picker.open()"
        [ngClass]="{'data-required':control.touched && control.invalid}"
        style="border-radius: 0 0.185rem 0.185rem 0; width: 40px; max-width: 40px; padding: 7px;">

        <mat-icon class="text-primary pj-ico-120">calendar_today</mat-icon>

        <mat-datepicker [startView]="startView" #picker (monthSelected)="monthChanged($event, picker)" [calendarHeaderComponent]="inputDateMonthHeader"></mat-datepicker>
    </button>
</div>
 